<template>
  <div id="content">
    <div class="col-xs-12 center-block">
      <div id="flower-2" class="center">
        <img src="../assets/characters_long.png" alt="flower 2" />
      </div>
      <div class="text" :class="textFont">
        <p class="names">
          {{ $t("us.us") }}
        </p>
        <p>
          <span> {{ $t("us.date") }} </span>
          {{ $t("us.invite") }}
        </p>
        <p id="clock">
          {{ $t("us.remain") }}
          <span class="days"></span> {{ $t("us.days") }},
          <span class="hours"></span> {{ $t("us.hours") }},
          <span class="minutes"></span> {{ $t("us.minutes") }}
          {{ $t("us.and") }}
          <span class="seconds"></span> {{ $t("us.seconds") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>

function getTimeRemaining (endtime) {
  var t = Date.parse(new Date()) - Date.parse(endtime)
  var seconds = Math.floor((t / 1000) % 60)
  var minutes = Math.floor((t / 1000 / 60) % 60)
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24)
  var days = Math.floor(t / (1000 * 60 * 60 * 24))
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  }
}

function initializeClock (id, endtime) {
  var clock = document.getElementById(id)
  var daysSpan = clock.querySelector('.days')

  var hoursSpan = clock.querySelector('.hours')
  var minutesSpan = clock.querySelector('.minutes')
  var secondsSpan = clock.querySelector('.seconds')

  function updateClock () {
    var t = getTimeRemaining(endtime)

    daysSpan.innerHTML = t.days
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2)
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2)
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2)

    if (t.total <= 0) {
      clearInterval(timeinterval)
    }
  }

  updateClock()
  var timeinterval = setInterval(updateClock, 1000)
}

export default {
  name: 'Us',
  data () {
    return {
      msg: ''
    }
  },
  computed: {
    textFont: function () {
      return {
        'text-ge': this.$i18n.locale === 'ge',
        'text-fr': this.$i18n.locale === 'fr'
      }
    }
  },
  mounted: function () {
    initializeClock('clock', new Date('2018-09-08'))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$blue-dark: darken(#0176A6, 15%);
$red: #d798a8;

.names {
  margin-top: -22px;
  font-size: 1.2em;
  color: $red;
}

.center {
  text-align: center;
}

.center > img {
  max-width: 100%;
}

.text {
  text-align: center;
  font-size: 2.8em;
  color: $blue-dark;
}

.text-ge {
  font-family: 'Saba';
}

.text-fr {
  font-family: 'Dancing Script';
}

</style>



// WEBPACK FOOTER //
// src/components/Us.vue